import React, { useEffect, useState, useCallback } from "react";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import cities from "./mock";

//import roteNdaoGeo from '../../../../assets/jsonData/kab_Rote.json';
import roteNdaoGeo from "../../assets/jsonData/kab_Rote.json";

import "./tooltip.css";
// Fungsi untuk menghasilkan warna acak
import { DATA_DISABILITAS_GROUP } from "../../utils";
import axios from "axios";

const Am4chartMap = ({
  selectedIndicator = "total_disabilitas",
  selectedYear = 2025,
}) => {
  const [listDesa, setListDesa] = useState([]);
  const features = roteNdaoGeo.features;
  const [mapCombine, setMapCombine] = useState();

  // Fungsi untuk menentukan warna berdasarkan nilai indikator disabilitas
  const getColorByValue = (value) => {
    if (value === 0) return "#E8E8E8"; // Abu-abu terang - tidak ada data
    if (value <= 5) return "#90EE90"; // Hijau muda - 1-5 orang (rendah)
    if (value <= 15) return "#32CD32"; // Hijau - 6-15 orang (sedang)
    if (value <= 30) return "#FFD700"; // Kuning - 16-30 orang (tinggi)
    if (value <= 50) return "#FF8C00"; // Orange - 31-50 orang (sangat tinggi)
    return "#FF4500"; // Merah - 51+ orang (kritis)
  };

  // Fungsi untuk mendapatkan label indikator disabilitas
  const getIndicatorLabel = (indicatorKey) => {
    const labelMap = {
      total_disabilitas: "Total Disabilitas",
      laki_laki: "Laki-laki",
      perempuan: "Perempuan",
      disabilitas_netra_buta: "Disabilitas Netra/Buta",
      disabilitas_mental_jiwa: "Disabilitas Mental/Jiwa",
      disabilitas_fisik: "Disabilitas Fisik",
      disabilitas_fisik_mental: "Disabilitas Fisik & Mental",
      disabilitas_rungu_wicara: "Disabilitas Rungu/Wicara",
      disabilitas_lainnya: "Disabilitas Lainnya",
    };

    return labelMap[indicatorKey] || "Indikator Disabilitas";
  };

  const combineData = useCallback(() => {
    var desaku = [];
    var desa;

    // Debug log untuk melihat data yang tersedia
    console.log("ListDesa data:", listDesa);
    console.log("Features length:", features.length);
    console.log(
      "Sample desa names from geojson:",
      features.slice(0, 5).map((f) => f.properties.DESA)
    );

    // Mapping kecamatan ke desa yang ada di data geografis
    const kecamatanMapping = {
      LOBAIN: ["Oeseli", "Lalukoen", "Oehandi", "Lekik", "Dolasi", "Temas"],
      "NDAO NUSE": [
        "Modosinal",
        "Netenaen",
        "Ingguinak",
        "Oebela",
        "Namodale",
        "Mokdale",
        "Kolobolon",
        "Holoama",
        "Tuanatuk",
        "Oematamboli",
        "Suelain",
        "Baadale",
        "Onatali",
        "Maubesi",
        "Limakoli",
        "Lidamanu",
        "Suebela",
        "Lidabesi",
        "Nusakdale",
        "Batulilok",
        "Lenupetu",
        "Sonimanu",
        "Oebau",
        "Keoen",
        "Edalode",
        "Tungganamo",
        "Faifua",
        "Hundihopo",
        "Serubeba",
        "Matasio",
        "Sedeoen",
        "Nemberala",
        "Oenggaut",
        "Bo'a",
        "Oenitas",
        "Oelolot",
        "Mbueain",
        "Dodaek",
        "Tebole",
        "Inaoe",
        "Oeledo",
        "Oenggae",
        "Kuli",
        "Fua Funi",
        "Mbokak",
        "Sangga Ndolu",
        "Oebatu",
        "Dalek Esa",
        "Hundihuk",
        "Saindule",
        "Oetutulu",
        "Busalangga Timur",
        "Lakamola",
        "Pengodua",
        "Papela",
        "Fatelilo",
        "Siomeda",
        "Nggodimeda",
      ],
      "ROTE BARAT": [
        "Oeseli",
        "Lalukoen",
        "Oehandi",
        "Lekik",
        "Dolasi",
        "Temas",
      ],
      "ROTE TENGAH": [
        "Modosinal",
        "Netenaen",
        "Ingguinak",
        "Oebela",
        "Namodale",
        "Mokdale",
        "Kolobolon",
        "Holoama",
        "Tuanatuk",
        "Oematamboli",
        "Suelain",
        "Baadale",
        "Onatali",
        "Maubesi",
        "Limakoli",
        "Lidamanu",
        "Suebela",
        "Lidabesi",
        "Nusakdale",
        "Batulilok",
        "Lenupetu",
        "Sonimanu",
        "Oebau",
        "Keoen",
        "Edalode",
        "Tungganamo",
        "Faifua",
        "Hundihopo",
        "Serubeba",
        "Matasio",
        "Sedeoen",
        "Nemberala",
        "Oenggaut",
        "Bo'a",
        "Oenitas",
        "Oelolot",
        "Mbueain",
        "Dodaek",
        "Tebole",
        "Inaoe",
        "Oeledo",
        "Oenggae",
        "Kuli",
        "Fua Funi",
        "Mbokak",
        "Sangga Ndolu",
        "Oebatu",
        "Dalek Esa",
        "Hundihuk",
        "Saindule",
        "Oetutulu",
        "Busalangga Timur",
        "Lakamola",
        "Pengodua",
        "Papela",
        "Fatelilo",
        "Siomeda",
        "Nggodimeda",
      ],
      "ROTE TIMUR": [
        "Modosinal",
        "Netenaen",
        "Ingguinak",
        "Oebela",
        "Namodale",
        "Mokdale",
        "Kolobolon",
        "Holoama",
        "Tuanatuk",
        "Oematamboli",
        "Suelain",
        "Baadale",
        "Onatali",
        "Maubesi",
        "Limakoli",
        "Lidamanu",
        "Suebela",
        "Lidabesi",
        "Nusakdale",
        "Batulilok",
        "Lenupetu",
        "Sonimanu",
        "Oebau",
        "Keoen",
        "Edalode",
        "Tungganamo",
        "Faifua",
        "Hundihopo",
        "Serubeba",
        "Matasio",
        "Sedeoen",
        "Nemberala",
        "Oenggaut",
        "Bo'a",
        "Oenitas",
        "Oelolot",
        "Mbueain",
        "Dodaek",
        "Tebole",
        "Inaoe",
        "Oeledo",
        "Oenggae",
        "Kuli",
        "Fua Funi",
        "Mbokak",
        "Sangga Ndolu",
        "Oebatu",
        "Dalek Esa",
        "Hundihuk",
        "Saindule",
        "Oetutulu",
        "Busalangga Timur",
        "Lakamola",
        "Pengodua",
        "Papela",
        "Fatelilo",
        "Siomeda",
        "Nggodimeda",
      ],
      "ROTE SELATAN": [
        "Modosinal",
        "Netenaen",
        "Ingguinak",
        "Oebela",
        "Namodale",
        "Mokdale",
        "Kolobolon",
        "Holoama",
        "Tuanatuk",
        "Oematamboli",
        "Suelain",
        "Baadale",
        "Onatali",
        "Maubesi",
        "Limakoli",
        "Lidamanu",
        "Suebela",
        "Lidabesi",
        "Nusakdale",
        "Batulilok",
        "Lenupetu",
        "Sonimanu",
        "Oebau",
        "Keoen",
        "Edalode",
        "Tungganamo",
        "Faifua",
        "Hundihopo",
        "Serubeba",
        "Matasio",
        "Sedeoen",
        "Nemberala",
        "Oenggaut",
        "Bo'a",
        "Oenitas",
        "Oelolot",
        "Mbueain",
        "Dodaek",
        "Tebole",
        "Inaoe",
        "Oeledo",
        "Oenggae",
        "Kuli",
        "Fua Funi",
        "Mbokak",
        "Sangga Ndolu",
        "Oebatu",
        "Dalek Esa",
        "Hundihuk",
        "Saindule",
        "Oetutulu",
        "Busalangga Timur",
        "Lakamola",
        "Pengodua",
        "Papela",
        "Fatelilo",
        "Siomeda",
        "Nggodimeda",
      ],
    };

    for (let i = 0; i < features.length; i++) {
      desa = features[i];

      // eslint-disable-next-line no-loop-func
      var dataDesa = listDesa.filter((item) => {
        const desaName = desa.properties.DESA.toUpperCase();
        const itemKecamatan = item["kecamatan"].toUpperCase();

        // Cek apakah desa ini termasuk dalam kecamatan tertentu
        const desaInKecamatan = kecamatanMapping[itemKecamatan] || [];
        const isDesaInKecamatan = desaInKecamatan.some(
          (desaInList) => desaInList.toUpperCase() === desaName
        );

        // Debug log untuk beberapa desa pertama
        if (i < 5) {
          console.log(
            `Comparing: "${desaName}" with kecamatan "${itemKecamatan}" - Is in kecamatan: ${isDesaInKecamatan}`
          );
          console.log(
            `Available desa in kecamatan ${itemKecamatan}:`,
            desaInKecamatan
          );
        }

        return isDesaInKecamatan;
      });

      // Debug log untuk melihat hasil matching
      if (i < 5) {
        console.log(
          `Desa ${i}: ${desa.properties.DESA} - Found matches: ${dataDesa.length}`
        );
        if (dataDesa.length > 0) {
          console.log(`Matched data:`, dataDesa[0]);
        }
      }

      if (dataDesa.length > 0) {
        const desaData = dataDesa[0];
        // Gunakan data indikator disabilitas yang dipilih
        const indicatorValue = desaData[selectedIndicator] || 0;

        desa.properties.indicatorValue = indicatorValue;
        desa.properties.kecamatan = desaData.kecamatan;
        desa.properties.color = getColorByValue(indicatorValue);
        // Tambahkan data tambahan untuk tooltip
        desa.properties.total_disabilitas = desaData.total_disabilitas || 0;
        desa.properties.laki_laki = desaData.laki_laki || 0;
        desa.properties.perempuan = desaData.perempuan || 0;
        desa.properties.disabilitas_netra_buta =
          desaData.disabilitas_netra_buta || 0;
        desa.properties.disabilitas_mental_jiwa =
          desaData.disabilitas_mental_jiwa || 0;
        desa.properties.disabilitas_fisik = desaData.disabilitas_fisik || 0;
        desa.properties.disabilitas_fisik_mental =
          desaData.disabilitas_fisik_mental || 0;
        desa.properties.disabilitas_rungu_wicara =
          desaData.disabilitas_rungu_wicara || 0;
        desa.properties.disabilitas_lainnya = desaData.disabilitas_lainnya || 0;
      } else {
        desa.properties.indicatorValue = 0;
        desa.properties.kecamatan = "";
        desa.properties.color = "#E8E8E8"; // Abu-abu terang untuk tidak ada data
        desa.properties.total_disabilitas = 0;
        desa.properties.laki_laki = 0;
        desa.properties.perempuan = 0;
        desa.properties.disabilitas_netra_buta = 0;
        desa.properties.disabilitas_mental_jiwa = 0;
        desa.properties.disabilitas_fisik = 0;
        desa.properties.disabilitas_fisik_mental = 0;
        desa.properties.disabilitas_rungu_wicara = 0;
        desa.properties.disabilitas_lainnya = 0;
      }

      desaku.push(desa);
    }

    const datamap = {
      type: "FeatureCollection",
      features: desaku,
    };

    setMapCombine(datamap);
  }, [listDesa, selectedIndicator, features]);

  const getListDesa = async () => {
    var data1 = [];

    try {
      // Gunakan endpoint data disabilitas dengan breakdown jenis
      const response = await axios.get(
        `${DATA_DISABILITAS_GROUP}kecamatan-jenis`
      );

      if (response.data.success) {
        data1 = response.data.data;
        console.log("Backend data kecamatan-jenis:", data1);
        console.log(
          "Sample kecamatan names:",
          data1.map((item) => item.kecamatan)
        );

        if (data1.length > 0) {
          setListDesa(data1);
        } else {
          setListDesa([]);
        }
      } else {
        console.log("Backend response tidak berhasil:", response.data);
        setListDesa([]);
      }
    } catch (error) {
      console.error("Error fetching data disabilitas:", error);
      // Fallback data untuk testing
      const fallbackData = [
        {
          kecamatan: "LOBAIN",
          total_disabilitas: 150,
          laki_laki: 80,
          perempuan: 70,
          disabilitas_netra_buta: 10,
          disabilitas_mental_jiwa: 5,
          disabilitas_fisik: 10,
          disabilitas_fisik_mental: 5,
          disabilitas_rungu_wicara: 5,
          disabilitas_lainnya: 5,
        },
        {
          kecamatan: "NDAO NUSE",
          total_disabilitas: 120,
          laki_laki: 65,
          perempuan: 55,
          disabilitas_netra_buta: 8,
          disabilitas_mental_jiwa: 4,
          disabilitas_fisik: 8,
          disabilitas_fisik_mental: 4,
          disabilitas_rungu_wicara: 4,
          disabilitas_lainnya: 4,
        },
      ];
      console.log("Using fallback data:", fallbackData);
      setListDesa(fallbackData);
    }
  };

  useEffect(() => {
    getListDesa();
  }, []);

  useEffect(() => {
    combineData();
  }, [combineData]);

  useEffect(() => {
    if (mapCombine) {
      // Hapus semua chart yang ada sebelum membuat yang baru
      am4core.disposeAllCharts();

      let map = am4core.create("map", am4maps.MapChart);
      map.geodata = mapCombine;
      map.percentHeight = 90;
      map.dy = 10;

      let polygonSeries = map.series.push(new am4maps.MapPolygonSeries());
      polygonSeries.useGeodata = true;
      map.homeZoomLevel = 1;
      map.zoomControl = new am4maps.ZoomControl();
      map.zoomControl.layout = "horizontal";
      map.zoomControl.align = "left";
      map.zoomControl.valign = "bottom";
      map.zoomControl.dy = 30;
      map.zoomControl.dx = 30;
      map.zoomControl.contentHeight = 20;
      map.zoomControl.minusButton.background.fill = am4core.color("#C7D0FF");
      map.zoomControl.minusButton.background.stroke = am4core.color("white");
      map.zoomControl.minusButton.label.fontWeight = 600;
      map.zoomControl.minusButton.label.fontSize = 22;
      map.zoomControl.minusButton.scale = 0.75;
      map.zoomControl.minusButton.label.scale = 0.75;
      map.zoomControl.plusButton.background.fill = am4core.color("#C7D0FF");
      map.zoomControl.plusButton.background.stroke = am4core.color("#6979C9");
      map.zoomControl.plusButton.label.fontWeight = 600;
      map.zoomControl.plusButton.label.fontSize = 22;
      map.zoomControl.plusButton.label.align = "center";
      map.zoomControl.plusButton.scale = 0.75;
      map.zoomControl.plusButton.label.scale = 0.75;
      map.zoomControl.plusButton.dx = 5;

      let plusButtonHoverState =
        map.zoomControl.plusButton.background.states.create("hover");
      plusButtonHoverState.properties.fill = am4core.color("#354D84");
      let minusButtonHoverState =
        map.zoomControl.minusButton.background.states.create("hover");
      minusButtonHoverState.properties.fill = am4core.color("#354D84");

      let polygonTemplate = polygonSeries.mapPolygons.template;

      // Update tooltip untuk menampilkan data indikator yang dipilih
      polygonTemplate.tooltipHTML = `
        <div className="custom-tooltip">
          <b>{DESA} - {kecamatan}</b>
          <br><strong>${getIndicatorLabel(
            selectedIndicator
          )}:</strong> {indicatorValue} orang
          <br><strong>Total Disabilitas:</strong> {total_disabilitas} orang
          <br><strong>Laki-laki:</strong> {laki_laki} orang | <strong>Perempuan:</strong> {perempuan} orang
          <br><strong>Jenis Disabilitas:</strong>
          <br>• Netra/Buta: {disabilitas_netra_buta} orang
          <br>• Mental/Jiwa: {disabilitas_mental_jiwa} orang
          <br>• Fisik: {disabilitas_fisik} orang
          <br>• Fisik & Mental: {disabilitas_fisik_mental} orang
          <br>• Rungu/Wicara: {disabilitas_rungu_wicara} orang
          <br>• Lainnya: {disabilitas_lainnya} orang
        </div>
      `;

      polygonSeries.events.on("datavalidated", () => {
        polygonSeries.mapPolygons.each((polygon) => {
          let color = polygon.dataItem.dataContext.color;
          polygon.fill = color;
        });
      });

      polygonTemplate.stroke = am4core.color("white");
      let hs = polygonTemplate.states.create("hover");
      hs.properties.fill = am4core.color("blue");

      let citySeries = map.series.push(new am4maps.MapImageSeries());
      citySeries.data = cities;
      citySeries.dataFields.value = "size";
      let city = citySeries.mapImages.template;
      city.nonScaling = true;
      city.propertyFields.latitude = "latitude";
      city.propertyFields.longitude = "longitude";
      let circle = city.createChild(am4core.Circle);
      circle.fill = am4core.color("#C7D0FF");
      circle.strokeWidth = 0;
      let circleHoverState = circle.states.create("hover");
      circleHoverState.properties.strokeWidth = 1;
      circle.tooltipText = "{tooltip}";
      circle.propertyFields.radius = "size";

      // Cleanup function
      return () => {
        if (map) {
          map.dispose();
        }
      };
    }
  }, [mapCombine, selectedIndicator]);

  // Cleanup effect
  useEffect(() => {
    return () => {
      am4core.disposeAllCharts();
    };
  }, []);

  return (
    <>
      <div style={{ height: "100%", width: "100%", position: "relative" }}>
        <div id="map" style={{ height: "100%", width: "100%" }}></div>
      </div>

      {/* Legend */}
      <div
        style={{
          position: "absolute",
          bottom: "30px",
          right: "30px",
          background: "#ffffff",
          padding: "16px",
          borderRadius: "12px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
          fontSize: "13px",
          minWidth: "200px",
          zIndex: 9999,
          border: "1px solid rgba(0,0,0,0.1)",
          transform: "translateZ(0)",
          willChange: "transform",
          display: "block",
          visibility: "visible",
          opacity: "1",
        }}
      >
        <div
          style={{
            fontWeight: "bold",
            marginBottom: "12px",
            fontSize: "14px",
            color: "#333",
            borderBottom: "1px solid #e0e0e0",
            paddingBottom: "8px",
            textShadow: "none",
          }}
        >
          <i className="tim-icons icon-chart-bar-32 mr-2"></i>
          Keterangan Sebaran Disabilitas:
        </div>
        <div
          style={{
            fontSize: "11px",
            color: "#666",
            marginBottom: "12px",
            fontStyle: "italic",
          }}
        >
          Berdasarkan jumlah per desa
        </div>
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
        >
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#E8E8E8",
              marginRight: "10px",
              borderRadius: "3px",
              border: "1px solid rgba(0,0,0,0.1)",
            }}
          ></div>
          <span style={{ fontSize: "12px", color: "#555" }}>
            Tidak ada data
          </span>
        </div>
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
        >
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#90EE90",
              marginRight: "10px",
              borderRadius: "3px",
              border: "1px solid rgba(0,0,0,0.1)",
            }}
          ></div>
          <span style={{ fontSize: "12px", color: "#555" }}>
            Rendah (1-5 orang)
          </span>
        </div>
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
        >
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#32CD32",
              marginRight: "10px",
              borderRadius: "3px",
              border: "1px solid rgba(0,0,0,0.1)",
            }}
          ></div>
          <span style={{ fontSize: "12px", color: "#555" }}>
            Sedang (6-15 orang)
          </span>
        </div>
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
        >
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#FFD700",
              marginRight: "10px",
              borderRadius: "3px",
              border: "1px solid rgba(0,0,0,0.1)",
            }}
          ></div>
          <span style={{ fontSize: "12px", color: "#555" }}>
            Tinggi (16-30 orang)
          </span>
        </div>
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
        >
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#FF8C00",
              marginRight: "10px",
              borderRadius: "3px",
              border: "1px solid rgba(0,0,0,0.1)",
            }}
          ></div>
          <span style={{ fontSize: "12px", color: "#555" }}>
            Sangat Tinggi (31-50 orang)
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#FF4500",
              marginRight: "10px",
              borderRadius: "3px",
              border: "1px solid rgba(0,0,0,0.1)",
            }}
          ></div>
          <span style={{ fontSize: "12px", color: "#555" }}>
            Kritis (51+ orang)
          </span>
        </div>
        <div
          style={{
            marginTop: "12px",
            paddingTop: "8px",
            borderTop: "1px solid #e0e0e0",
            fontSize: "11px",
            color: "#666",
          }}
        >
          <i className="tim-icons icon-info text-info mr-1"></i>
          Hover pada desa untuk detail lengkap
        </div>
      </div>
    </>
  );
};

export default Am4chartMap;
